import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { InputBaseField, SelectField } from '../../../../components/InputField/InputField';
import { PostDataAPI } from '../../../../Services/APIService';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements';
import DialogLoader from './../../../../components/Loader/DialogLoader';
import { handleNumberWithDecimal, formateMdnNumber, handleNumberKeyPress, validatePhoneNumber, handleNegativeNumberWithDecimal } from '../../../../components/Common/Extensions';
import { withSnackbar } from "../../../../components/Message/Alert";

function AddCash({ dialogOpenClose, handleClose, handleSuccessClose, accountNumber, mdnNumber, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [errorMessages, setErrorMessages] = useState({
        errorPhoneLength: false
    })
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({ phoneNumber: '' });
    const [wirelessLine, setWirelessLines] = useState([]);
    const [lineApproved, setLineApproved] = useState(false);
    const [lineInformation, setLineInformation] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const getCustomerLines = () => {
        var obj = {
            AccountNumber: accountNumber
        };
        PostDataAPI("customer/getCustomerLines", obj, true).then((result) => {
         
            if (result.success && result.data != null) {
                setWirelessLines(prevState => [...prevState, { value: '', label: 'Select Phone Number' }]);
                var activeLines = result.data.filter(item => item.status == 'Active');
                if (activeLines && activeLines.length > 0) {
                    activeLines.map((item, i) => {
                        setWirelessLines(prevState => [...prevState, { value: item.mdn, label: formateMdnNumber(item.mdn) }]);
                    })
                    const primaryMdn = activeLines.filter((item) => item.is_primary == true);
                    if (primaryMdn) {
                        setState(prevState => ({
                            ...prevState,
                            ['phoneNumber']: primaryMdn[0].mdn
                        }));
                    }
                } else {
                    showMessage("Error","Active line not exists", "error", 3000);
                }
                
            }
        })
    }

    const Validate = (errorList) => {
        //if (!state.phoneNumber) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorPhone: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorPhone: false
        //    }));
        //}
        //if (state.phoneNumber && !validatePhoneNumber(state.phoneNumber)) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorInvalidPhone: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorInvalidPhone: false
        //    }));
        //}

        if (!state.cash) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCash: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCash: false
            }));
        }

        
    }

    const handleAddButtonClickAction = () => {
        addCashToLine();
        //let errorList = [];
        //Validate(errorList);
        //
        //if (errorList.length < 1) {
        //    getLineInformation(state.phoneNumber);
        //}
    }


    const addCashToLine = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            var obj = {
                AccountNumber: accountNumber,
                mdn: mdnNumber,
                cash: parseFloat(state.cash),
                IsPrepaid: true
            };
            setLoading(true);
            PostDataAPI("telispire/updateLineCash", obj, true).then((result) => {
                setLoading(false);
                if (result.success) {
                    handleSuccessClose("Cash added to line successfully")
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }

            })
        }

       

    }

    const getLineInformation = (mdnNumber) => {
        var obj = {
            mdn: mdnNumber
        };
        setLoading(true);
        PostDataAPI("telispire/getWirelesssByMDN", obj, true).then((result) => {
            setLoading(false);
            if (result.success && result.data != null) {
                setLineInformation(result.data);
                console.log(result.data);
                setLineApproved(true);
            }
            else {
                //show line error message
                showMessage("Error", result.message, "error", 3000);
                setLineApproved(false);
            }
            
        })
    }

    useEffect(() => {
    }, []);


    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Add Cash - {formateMdnNumber(mdnNumber)}</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <div className={classes.content}>
                        {loading ? <DialogLoader></DialogLoader> : ''}
                     
                            <Grid row style={{paddingTop: '10px'}}>
                      
                                <Grid container direction="column">

                                    <Grid xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>
                                    <Label title="Amount $" size={12} mandatory={true} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="cash"
                                                name="cash"
                                                type="text"
                                                placeholder="Amount"
                                                MaxLength='5'
                                                onChange={handleChange}
                                                onKeyPress={(e) => handleNegativeNumberWithDecimal(e)}
                                            />
                                            {errorMessages.errorCash && !state.cash ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter amount
                                            </FormHelperText>) : ('')}
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>

                     
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={handleAddButtonClickAction}>Add</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(AddCash);